module.exports = __webpack_public_path__ + "img/yritysluottoflex@2x.c17f7a4.png";